import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/student-card-activators', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-card-activators', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/student-card-activators/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const change = data => {
  return httpClient
    .post('/api/student-card-activators/change/status', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const checkCurrentStudentCardStatus = data => {
  return httpClient
    .post('/api/student-card-activators/check-card-exists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCardStatus = (Option = {}) => {
  return httpClient
    .get('/api/student-card-activators/attendance/card-status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  update,
  change,
  checkCurrentStudentCardStatus,
  getCardStatus
}
